import Link from 'next/link';

export const passwordResetErrorMessageFallback =
  'Sorry, an unknown error occurred.';
export const passwordResetFriendlyErrorMessages = {
  ACCOUNT_NOT_FOUND: 'Account with that email address could not be found',
  ACCOUNT_CLOSED:
    'This account has been closed. Please email us if you would like it re-opened: hello@daymade.co.uk',
  ACCOUNT_FROZEN:
    'This account has been frozen. Please email us if you would like it unfrozen: hello@daymade.co.uk',
  PASSWORD_RESET_NOT_AVAILABLE: 'Reset password not available for this account',
  TOKEN_NOT_FOUND: 'Sorry, that password reset link was not valid',
  TOKEN_EXPIRED: (
    <>
      Sorry, that password reset link has expired. Please{' '}
      <Link href="/password-reset">request a new one</Link>
    </>
  ),
  TOKEN_ALREADY_USED: (
    <>
      Sorry, that password reset link has already been used. Please{' '}
      <Link href="/password-reset">request a new one</Link>
    </>
  ),
} as const;
